import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import useModels from "../../api/hooks/useModels";
import LogMessage from "../../components/misc/LogMessage";
import MyNavigator from "../../components/misc/MyNavigator";
import NavBar from "../../components/misc/NavBar";
import SearchBar from "../../components/misc/Searcbar";
import SideBar from "../../components/misc/SideBar";
import ModelCard from "../../components/models/ModelCard";
import ModelPageTopButton from "../../components/models/ModelPageTopButton";
import ModelsFilter from "../../components/models/ModelsFilter";
import { logMsgBgColors } from "../../consts/misc";
import { mockModelsSelected } from "../../consts/mocks";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import useLogMessage from "../../hooks/useLogMessage";
import useToggle from "../../hooks/useToggle";
import { Model } from "../../interfaces";
import "../../styles/Models.css";
import {
  filterByPlace,
  filterByName,
  filterBySliderField,
  filterByTraits,
  finalFilter,
} from "../../utils/filters/modelFilter";
import { modelRemappingFromResult } from "../../utils/modelRemapping";
import FilterContext from "../../context/FilterContext";
import { backToTopOfPage } from "../../utils/others";

const ModelsPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const navigateNow = useToggle(false);
  const menuToggler = useToggle(false);

  const trigger = useToggle(false);
  const logMessage = useLogMessage();

  const { refresh, modelSelector, offer, pageHeight, setPageHeight } =
    useContext(MainContext);
  const filterCTX = useContext(FilterContext);

  const { RESPONSES, RESULTS, CTAs } = useModels();

  const categoriesToggler = useToggle(filterCTX.isCategoriesOpen);
  const featuresToggler = useToggle(filterCTX.isFeaturesOpen);
  const placeToggler = useToggle(filterCTX.isPlaceOpen);

  const isAnyFilterOpen =
    categoriesToggler.isToggled ||
    featuresToggler.isToggled ||
    placeToggler.isToggled;

  const modelsFilterByParamsForm = useForm();
  const modelsFilterByNameForm = useForm();
  const modelsFilterByCategoriesForm = useForm();
  const [modelsFilterByPlaceObject, setModelsFilterByPlaceObject] = useState(
    filterCTX.isPlaceOpen ? filterCTX.place : {}
  );

  const [modelsFilterByTraitsObject, setModelsFilterByTraitsObject] = useState(
    filterCTX.isFeaturesOpen ? filterCTX.traits : {}
  );
  const selectAllEyesToggler = useToggle(false);
  const selectAllHairToggler = useToggle(false);
  const selectAllPlaceToggler = useToggle(false);
  const resetFiltersToggler = useToggle(false);

  const { modelList } = modelSelector;
  const [modelSelectedQuantity, setModelSelectQuantity] = useState(0);

  const [modelsFetched, setModelFetched] = useState<Model[]>([]);
  const [modelsFilteredByName, setModelsFilteredByName] = useState<Model[]>([]);
  const [modelsFilteredByMeasures, setModelsFilteredByMeasures] = useState<
    Model[] | null
  >(null);
  const [modelsFilteredByPlace, setModelsFilteredByPlace] = useState<
    Model[] | null
  >([]);
  const [modelsFilteredByTraits, setModelsFilteredByTraits] = useState<
    Model[] | null
  >([]);
  const [modelsFilteredByCategory, setModelsFilteredByCategory] = useState<
    Model[] | null
  >(null);

  const [modelsFiltered, setModelsFiltered] = useState<Model[]>([]);
  const [modelsDisplayed, setModelsDisplayed] = useState<Model[]>([]);

  /*  const [loadMoreCounter, setLoadMoreCounter] = useState<number>(1); */

  const tempLoading = useToggle(false);

  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/models") {
      window.addEventListener("wheel", (e) => {
        if (window.scrollY === 0) {
          setPageHeight(window.scrollY);
        } else setPageHeight(e.pageY);
      });
    }
    if (window.location.pathname != "/models") {
      backToTopOfPage();
      window.addEventListener("wheel", () => setPageHeight(pageHeight));
    }
  });

  const [renderNumber, setRenderNumber] = useState(0);

  useEffect(() => {
    if (modelsDisplayed) {
      setRenderNumber((prevState) => prevState + 1);
    }
  }, [modelsDisplayed]);

  useEffect(() => {
    if (renderNumber < 9 && modelsDisplayed) {
      window.scrollTo(0, pageHeight);
    }
  }, [modelsDisplayed, renderNumber]);

  /* useEffect(() => {
    console.log(pageHeight);
  }, [pageHeight]); */

  useEffect(() => {
    const url = new URL(window.location.href);
    const isEmpty = url.searchParams.get("empty");
    if (isEmpty) {
      setIsEmpty(true);
    } else setIsEmpty(false);
  }, []);

  useEffect(() => {
    if (isEmpty) {
      navigateNow.setIsToggled(true);
    }
  }, [isEmpty]);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  useEffect(() => {
    if (modelsFiltered) {
      const modelsOnDisplay =
        modelsFiltered; /* .slice(0, 9 * loadMoreCounter) */
      setModelsDisplayed(modelsOnDisplay);
    }
  }, [modelsFiltered /* , loadMoreCounter */]);

  useEffect(() => {
    tempLoading.setIsToggled(true);
    CTAs.getModelsListAll();
  }, [refresh]);

  useEffect(() => {
    /*  console.log(
      RESPONSES.getModelsListAllResponse,
      RESULTS.getModelsListAllResult
    );     */
    tempLoading.setIsToggled(false);
    const result = RESULTS.getModelsListAllResult?.models;
    if (result) {
      const finalList: Model[] = [];
      result.forEach((model: any) => {
        const finalModel = modelRemappingFromResult(model);
        finalList.push(finalModel);
      });
      setModelsFilteredByName(finalList);
      setModelFetched(finalList);
    }
  }, [RESPONSES.getModelsListAllResponse]);

  useEffect(() => {
    if (resetFiltersToggler.isToggled) {
      resetFiltersToggler.toggle();
      setModelsFilteredByName(modelsFetched);
      const modelsOnDisplay = modelsFiltered; /* .slice(0, 9) */
      setModelsDisplayed(modelsOnDisplay);
      /* setLoadMoreCounter(1); */
    }
  }, [resetFiltersToggler]);

  useEffect(() => {
    setModelSelectQuantity(modelList.length);
  }, [modelList]);

  useEffect(() => {
    onFilterTraitsChange();
  }, [modelsFilterByTraitsObject]);

  useEffect(() => {
    onFilterPlaceChange();
  }, [modelsFilterByPlaceObject]);

  useEffect(() => {
    const finalFiltered = finalFilter(
      modelsFetched,
      modelsFilteredByName,
      modelsFilteredByMeasures,
      modelsFilteredByPlace,
      modelsFilteredByTraits,
      modelsFilteredByCategory
    );
    setModelsFiltered(finalFiltered);
  }, [
    modelsFilteredByName,
    modelsFilteredByMeasures,
    modelsFilteredByPlace,
    modelsFilteredByTraits,
    modelsFilteredByCategory,
  ]);

  useEffect(() => {
    trigger.setIsToggled((prevState) => !prevState);
  }, [modelsFiltered]);

  /// RIPRENDI DA QUI

  useEffect(() => {
    if (filterCTX.name) {
      modelsFilterByNameForm.setValue("name", filterCTX.name);
      const filteredList = filterByName(modelsFetched, filterCTX.name);
      if (filteredList) {
        setModelsFilteredByName(filteredList);
      }
    }
    if (filterCTX.isFeaturesOpen && filterCTX.params) {
      Object.entries(filterCTX.params).forEach(([a, b]) => {
        modelsFilterByParamsForm.setValue(a, b);
      });

      /*
      BUG: quando si apre il filtro features se non si modifica alcun input non si vede la lista....
      PROBABILE SOLVE: CONTROLLARE PERCHE' "filteredList" torna un oggetto vuoto al primo render */
      const filteredList = filterBySliderField(
        modelsFetched,
        filterCTX.params,
        "measures"
      );
      setModelsFilteredByMeasures(filteredList);
    }

    if (filterCTX.isFeaturesOpen && filterCTX.traits) {
      setModelsFilterByTraitsObject(filterCTX.traits);
    }

    if (filterCTX.categories && filterCTX.isCategoriesOpen) {
      Object.entries(filterCTX.categories).forEach(([a, b]) => {
        modelsFilterByCategoriesForm.setValue(a, b);
      });
      const filteredList = filterBySliderField(
        modelsFetched,
        filterCTX.categories,
        "work_categories"
      );
      setModelsFilteredByCategory(filteredList);
    }
    if (filterCTX.place && filterCTX.isPlaceOpen) {
      setModelsFilterByPlaceObject(filterCTX.place);
    }
  }, [modelsFetched, isAnyFilterOpen]);

  ///

  const onFilterNameChange = (data: any) => {
    filterCTX.setName(data.name);
    const filteredList = filterByName(modelsFetched, data.name);
    if (filteredList) {
      setModelsFilteredByName(filteredList);
    }
  };

  const onFilterParamsChange = (data: any) => {
    filterCTX.setParams({ ...data });
    const filteredList = filterBySliderField(modelsFetched, data, "measures");
    setModelsFilteredByMeasures(filteredList);
  };

  const onFilterTraitsChange = () => {
    filterCTX.setTraits({ ...modelsFilterByTraitsObject });
    const filteredList = filterByTraits(
      modelsFetched,
      modelsFilterByTraitsObject
    );
    setModelsFilteredByTraits(filteredList);
  };

  const onFilterCategoriesChange = (data: any) => {
    filterCTX.setCategories({ ...data });
    const filteredList = filterBySliderField(
      modelsFetched,
      data,
      "work_categories"
    );
    setModelsFilteredByCategory(filteredList);
  };

  const onFilterPlaceChange = () => {
    filterCTX.setPlace({ ...modelsFilterByPlaceObject });
    const filteredList = filterByPlace(
      modelsFetched,
      modelsFilterByPlaceObject
    );
    setModelsFilteredByPlace(filteredList);
  };

  const resetAllFilters = () => {
    resetFiltersToggler.toggle();
    modelsFilterByNameForm.resetField("name");
  };

  const renderModelsCard = modelsDisplayed?.map((model: Model, key: number) => {
    return (
      <ModelCard
        key={key}
        model={model}
        setModelSelectQuantity={setModelSelectQuantity}
        trigger={trigger.isToggled}
      />
    );
  });

  const filterBox = (
    <ModelsFilter
      byParamsForm={modelsFilterByParamsForm}
      byParamsHandler={onFilterParamsChange}
      byCategoriesForm={modelsFilterByCategoriesForm}
      byCategoriesHandler={onFilterCategoriesChange}
      byPlaceSetAction={setModelsFilterByPlaceObject}
      byTraitsSetAction={setModelsFilterByTraitsObject}
      selectAllEyesToggler={selectAllEyesToggler}
      selectAllHairToggler={selectAllHairToggler}
      selectAllPlaceToggler={selectAllPlaceToggler}
      resetFiltersToggler={resetFiltersToggler}
      resetAllFilters={resetAllFilters}
      categoriesToggler={categoriesToggler}
      featuresToggler={featuresToggler}
      placeToggler={placeToggler}
    />
  );

  return (
    <div className="page-wrapper">
      <MyNavigator
        path={isEmpty ? `/models/create` : `/offers/${offer?.id}`}
        trigger={navigateNow}
      />
      {(!isMobile || menuToggler.isToggled) && (
        <SideBar toggler={menuToggler} />
      )}
      <div style={{ width: "100%" }}>
        {isMobile && <NavBar toggler={menuToggler} />}
        <div
          className={`page-content ${
            isMobile && menuToggler.isToggled
              ? menuToggler.isToggledSecondary
                ? "slide-right"
                : "slide-left"
              : ""
          }`}
          style={{
            maxWidth: isMobile ? "" : "calc(100vw - 306px)",
            minWidth: isMobile ? "" : "605px",
            marginLeft: isMobile
              ? menuToggler.isToggled
                ? "256px"
                : ""
              : "256px",
          }}
        >
          {logMessage.isToggled && (
            <LogMessage
              text={{
                subject: logMessage.message.subject,
                other_text: logMessage.message.other_text,
                complement: logMessage.message.complement,
              }}
              bgColor={logMessage.message.bgColor}
            />
          )}
          <div
            className="header-box"
            style={{
              width: isMobile ? "345px" : "",
              margin: isMobile ? "0 auto" : "",
            }}
          >
            {modelSelector.onModelSelection && (
              <div
                className="Oval"
                onClick={() => navigateNow.setIsToggled(true)}
              >
                <img src={`${toIcons}/small-left.svg`} />
              </div>
            )}
            <p
              className={isMobile ? `titlePage-Mob` : `titlePage`}
              style={{
                width:
                  isMobile && modelSelector.onModelSelection
                    ? "fit-content"
                    : "",
              }}
            >
              {modelSelector.onModelSelection && "Add "}Models
            </p>
            {/*  {!isMobile && <SearchBar notify={true} />} */}
            {isMobile && (
              <ModelPageTopButton
                logMessage={logMessage}
                modelSelectedQuantity={modelSelectedQuantity}
                setModelSelectQuantity={setModelSelectQuantity}
              />
            )}
          </div>
          <div
            className="search-model-box shadow"
            style={{
              width: isMobile ? "345px" : "",
            }}
          >
            <div
              className="search-box-content"
              style={{ width: isMobile ? "" : "100%" }}
            >
              <form
                onChange={modelsFilterByNameForm.handleSubmit(
                  onFilterNameChange
                )}
              >
                <SearchBar
                  notify={false}
                  width={isMobile ? 230 : 332}
                  iconShift={isMobile ? 15 : 11}
                  register={modelsFilterByNameForm.register}
                  errors={modelsFilterByNameForm.formState.errors}
                />
              </form>
              {!isMobile && (
                <ModelPageTopButton
                  logMessage={logMessage}
                  modelSelectedQuantity={modelSelectedQuantity}
                  setModelSelectQuantity={setModelSelectQuantity}
                />
              )}
            </div>
          </div>

          <div
            className="models-preview-section"
            style={{
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "center" : "",
            }}
          >
            {isMobile && <div style={{}}>{filterBox}</div>}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: isMobile ? "345px" : "100%",
              }}
            >
              <div
                id="cards-box"
                className="models-preview-list-box"
                style={{
                  width: isMobile ? "345px" : "",
                  display: isMobile ? "flex" : "",
                  flexDirection: isMobile ? "column" : "unset",
                }}
              >
                {renderModelsCard}
              </div>
              {/* <div style={{ margin: "80px auto" }}>
                {modelsDisplayed.length < modelsFiltered.length && (
                  <button
                    className="button2"
                    type="button"
                    onClick={() => {
                      setLoadMoreCounter((prevCounter) => prevCounter + 1);
                    }}
                  >
                    <p className="button2-text">Load More</p>
                  </button>
                )}
              </div> */}
            </div>
            {!isMobile && filterBox}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ModelsPage;
